import { PropsWithClassName } from "../../../models/props-with-class-name";

import nextEnabledIcon from "../../../assets/shared/next_enabled.svg";
import nextDisabledIcon from "../../../assets/shared/next_disabled.svg";

import styles from "./NextPrevIcon.module.css";
import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
type NextPrevIconProps = {
  next?: boolean;
  disabled?: boolean;
};

const NextPrevIcon = ({
  next,
  disabled,
  className,
}: PropsWithClassName<NextPrevIconProps>) => (
  <BaseIcon
    icon={disabled ? nextDisabledIcon : nextEnabledIcon}
    className={`${styles.icon} ${!next ? styles.back : ""} ${className}`}
  />
);

export default NextPrevIcon;
